<button class="floating-button" title="ChatBot">
  <svg-icon
   alt="Chat Bot Avatar"
    src="../../../../../assets/core/chat-bot-avatar.svg"
  ></svg-icon>
</button>
